<template>
  <v-card color="primary">
    <v-form @submit="resetPasswordAction" onSubmit="return false;" >
      <v-card-title>{{ $t('resetPassword.resetPassword') }}</v-card-title>
        <input type="text" autocomplete="username" style="display: none" />
        <PasswordCreate 
          v-model="password"
          :getInProgress="getInProgress"
        />
      <v-btn type="submit">{{ $t('forms.submit') }}</v-btn>
    </v-form>
  </v-card>
</template>
<script>
import PasswordCreate from './PasswordCreate'
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    PasswordCreate,
  },
  computed: {
    ...mapGetters('auth/resetPassword', ['getInProgress', 'getSuccess', 'getErrorMessages']),
  },
  methods: {
    ...mapActions('auth/resetPassword', ['resetPassword']),
    resetPasswordAction() {
      this.resetPassword({token: this.$route.params.token, password: this.password})
    },
  },
  data() {
    return {
      password: '',
    }
  }
}
</script>